import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  AssertionError3yq7q0knw9m5 as AssertionError,
} from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { EOFException34hypof9gkxss as EOFException } from './NonJvmPlatform.mjs';
import { checkOffsetAndCount2b5icqlx5z1pu as checkOffsetAndCount } from './Util.mjs';
import {
  add2suhfggl4zvkk as add,
  fromInt2ii0rejb1w62w as fromInt,
  subtract2orl8z9upxd9l as subtract,
  convertToInty04h231mmjoh as convertToInt,
  numberToLong2pakxeg38estk as numberToLong,
} from '../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SegmentPool_instance1ixtbemlc1c8i as SegmentPool_instance } from './SegmentPool.mjs';
import {
  ByteString2qc03wzjsovk as ByteString,
  Companion_getInstancehg4q7a6mrz0y as Companion_getInstance,
} from './ByteString.mjs';
import { commonToUtf8Stringyih6e1qg1yoo as commonToUtf8String } from './internal/-Utf8.mjs';
import {
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  Char__toInt_impl_vasixd1ka89vowck9tn as Char__toInt_impl_vasixd,
} from '../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { toByte4i43936u611k as toByte } from '../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import {
  readUtf8Line36yidw3sdfobh as readUtf8Line,
  selectPrefix5tb3rl5iltlw as selectPrefix,
  commonIndexOf2u7nnfp9zp5hz as commonIndexOf,
} from './internal/Buffer.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { isArray1hxjqtqy632bc as isArray } from '../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { SegmentedByteString5e5x58c4yl7l as SegmentedByteString } from './SegmentedByteString.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var UnsafeCursorClass;
function UnsafeCursor() {
  if (UnsafeCursorClass === VOID) {
    class $ {
      constructor() {
        this.n3v_1 = null;
        this.o3v_1 = false;
        this.p3v_1 = null;
        this.q3v_1 = -1n;
        this.r3v_1 = null;
        this.s3v_1 = -1;
        this.t3v_1 = -1;
      }
      l6() {
        // Inline function 'okio.internal.commonClose' call
        // Inline function 'kotlin.check' call
        if (!!(this.n3v_1 == null)) {
          var message = 'not attached to a buffer';
          throw IllegalStateException().o(toString(message));
        }
        this.n3v_1 = null;
        this.p3v_1 = null;
        this.q3v_1 = -1n;
        this.r3v_1 = null;
        this.s3v_1 = -1;
        this.t3v_1 = -1;
      }
    }
    initMetadataForClass($, 'UnsafeCursor', UnsafeCursor);
    UnsafeCursorClass = $;
  }
  return UnsafeCursorClass;
}
var BufferClass;
function Buffer() {
  if (BufferClass === VOID) {
    class $ {
      constructor() {
        this.j3s_1 = null;
        this.k3s_1 = 0n;
      }
      u3v() {
        return this;
      }
      v3v() {
        return this.k3s_1 === 0n;
      }
      w3v(byteCount) {
        if (this.k3s_1 < byteCount)
          throw EOFException().a3w(null);
      }
      b3w(byteCount) {
        return this.k3s_1 >= byteCount;
      }
      c3w(out, offset, byteCount) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonCopyTo' call
          var offset_0 = offset;
          var byteCount_0 = byteCount;
          checkOffsetAndCount(this.k3s_1, offset_0, byteCount_0);
          if (byteCount_0 === 0n) {
            tmp$ret$0 = this;
            break $l$block;
          }
          out.k3s_1 = add(out.k3s_1, byteCount_0);
          var s = this.j3s_1;
          while (offset_0 >= fromInt(ensureNotNull(s).b3t_1 - s.a3t_1 | 0)) {
            offset_0 = subtract(offset_0, fromInt(s.b3t_1 - s.a3t_1 | 0));
            s = s.e3t_1;
          }
          while (byteCount_0 > 0n) {
            var copy = ensureNotNull(s).i3t();
            copy.a3t_1 = copy.a3t_1 + convertToInt(offset_0) | 0;
            var tmp = copy;
            var tmp0 = copy.a3t_1 + convertToInt(byteCount_0) | 0;
            // Inline function 'kotlin.comparisons.minOf' call
            var b = copy.b3t_1;
            tmp.b3t_1 = Math.min(tmp0, b);
            if (out.j3s_1 == null) {
              copy.f3t_1 = copy;
              copy.e3t_1 = copy.f3t_1;
              out.j3s_1 = copy.e3t_1;
            } else {
              ensureNotNull(ensureNotNull(out.j3s_1).f3t_1).k3t(copy);
            }
            byteCount_0 = subtract(byteCount_0, fromInt(copy.b3t_1 - copy.a3t_1 | 0));
            offset_0 = 0n;
            s = s.e3t_1;
          }
          tmp$ret$0 = this;
        }
        return tmp$ret$0;
      }
      y3t(pos) {
        var tmp$ret$0;
        $l$block_3: {
          // Inline function 'okio.internal.commonGet' call
          checkOffsetAndCount(this.k3s_1, pos, 1n);
          $l$block_4: {
            // Inline function 'okio.internal.seek' call
            var tmp0_elvis_lhs = this.j3s_1;
            var tmp;
            if (tmp0_elvis_lhs == null) {
              tmp$ret$0 = ensureNotNull(null).z3s_1[convertToInt(subtract(add(numberToLong(null.a3t_1), pos), -1n))];
              break $l$block_3;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var s = tmp;
            if (subtract(this.k3s_1, pos) < pos) {
              var offset = this.k3s_1;
              while (offset > pos) {
                s = ensureNotNull(s.f3t_1);
                offset = subtract(offset, fromInt(s.b3t_1 - s.a3t_1 | 0));
              }
              var tmp0 = s;
              var offset_0 = offset;
              tmp$ret$0 = ensureNotNull(tmp0).z3s_1[convertToInt(subtract(add(numberToLong(tmp0.a3t_1), pos), offset_0))];
              break $l$block_3;
            } else {
              var offset_1 = 0n;
              $l$loop: while (true) {
                var tmp0_0 = offset_1;
                // Inline function 'kotlin.Long.plus' call
                var other = s.b3t_1 - s.a3t_1 | 0;
                var nextOffset = add(tmp0_0, fromInt(other));
                if (nextOffset > pos)
                  break $l$loop;
                s = ensureNotNull(s.e3t_1);
                offset_1 = nextOffset;
              }
              var tmp0_1 = s;
              var offset_2 = offset_1;
              tmp$ret$0 = ensureNotNull(tmp0_1).z3s_1[convertToInt(subtract(add(numberToLong(tmp0_1.a3t_1), pos), offset_2))];
              break $l$block_3;
            }
          }
        }
        return tmp$ret$0;
      }
      d3w() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonCompleteSegmentByteCount' call
          var result = this.k3s_1;
          if (result === 0n) {
            tmp$ret$0 = 0n;
            break $l$block;
          }
          var tail = ensureNotNull(ensureNotNull(this.j3s_1).f3t_1);
          if (tail.b3t_1 < 8192 && tail.d3t_1) {
            result = subtract(result, fromInt(tail.b3t_1 - tail.a3t_1 | 0));
          }
          tmp$ret$0 = result;
        }
        return tmp$ret$0;
      }
      e3w() {
        // Inline function 'okio.internal.commonReadByte' call
        if (this.k3s_1 === 0n)
          throw EOFException().f3w();
        var segment = ensureNotNull(this.j3s_1);
        var pos = segment.a3t_1;
        var limit = segment.b3t_1;
        var data = segment.z3s_1;
        var _unary__edvuaz = pos;
        pos = _unary__edvuaz + 1 | 0;
        var b = data[_unary__edvuaz];
        this.k3s_1 = subtract(this.k3s_1, 1n);
        if (pos === limit) {
          this.j3s_1 = segment.j3t();
          SegmentPool_instance.r3t(segment);
        } else {
          segment.a3t_1 = pos;
        }
        return b;
      }
      w3s() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonReadInt' call
          if (this.k3s_1 < 4n)
            throw EOFException().f3w();
          var segment = ensureNotNull(this.j3s_1);
          var pos = segment.a3t_1;
          var limit = segment.b3t_1;
          if (fromInt(limit - pos | 0) < 4n) {
            // Inline function 'okio.and' call
            var tmp = (this.e3w() & 255) << 24;
            // Inline function 'okio.and' call
            var tmp_0 = tmp | (this.e3w() & 255) << 16;
            // Inline function 'okio.and' call
            var tmp_1 = tmp_0 | (this.e3w() & 255) << 8;
            // Inline function 'okio.and' call
            tmp$ret$0 = tmp_1 | this.e3w() & 255;
            break $l$block;
          }
          var data = segment.z3s_1;
          var _unary__edvuaz = pos;
          pos = _unary__edvuaz + 1 | 0;
          // Inline function 'okio.and' call
          var tmp_2 = (data[_unary__edvuaz] & 255) << 24;
          var _unary__edvuaz_0 = pos;
          pos = _unary__edvuaz_0 + 1 | 0;
          // Inline function 'okio.and' call
          var tmp_3 = tmp_2 | (data[_unary__edvuaz_0] & 255) << 16;
          var _unary__edvuaz_1 = pos;
          pos = _unary__edvuaz_1 + 1 | 0;
          // Inline function 'okio.and' call
          var tmp_4 = tmp_3 | (data[_unary__edvuaz_1] & 255) << 8;
          var _unary__edvuaz_2 = pos;
          pos = _unary__edvuaz_2 + 1 | 0;
          // Inline function 'okio.and' call
          var i = tmp_4 | data[_unary__edvuaz_2] & 255;
          this.k3s_1 = subtract(this.k3s_1, 4n);
          if (pos === limit) {
            this.j3s_1 = segment.j3t();
            SegmentPool_instance.r3t(segment);
          } else {
            segment.a3t_1 = pos;
          }
          tmp$ret$0 = i;
        }
        return tmp$ret$0;
      }
      g3w() {
        // Inline function 'okio.internal.commonReadByteString' call
        return this.h3w(this.k3s_1);
      }
      h3w(byteCount) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'okio.internal.commonReadByteString' call
          // Inline function 'kotlin.require' call
          if (!(byteCount >= 0n && byteCount <= 2147483647n)) {
            var message = 'byteCount: ' + byteCount.toString();
            throw IllegalArgumentException().n2(toString(message));
          }
          if (this.k3s_1 < byteCount)
            throw EOFException().f3w();
          if (byteCount >= 4096n) {
            // Inline function 'kotlin.also' call
            var this_0 = this.j3w(convertToInt(byteCount));
            this.l3s(byteCount);
            tmp$ret$0 = this_0;
            break $l$block_0;
          } else {
            tmp$ret$0 = new (ByteString())(this.i3w(byteCount));
            break $l$block_0;
          }
        }
        return tmp$ret$0;
      }
      k3w() {
        return this.z3t(this.k3s_1);
      }
      z3t(byteCount) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'okio.internal.commonReadUtf8' call
          // Inline function 'kotlin.require' call
          if (!(byteCount >= 0n && byteCount <= 2147483647n)) {
            var message = 'byteCount: ' + byteCount.toString();
            throw IllegalArgumentException().n2(toString(message));
          }
          if (this.k3s_1 < byteCount)
            throw EOFException().f3w();
          if (byteCount === 0n) {
            tmp$ret$0 = '';
            break $l$block_0;
          }
          var s = ensureNotNull(this.j3s_1);
          if (add(numberToLong(s.a3t_1), byteCount) > fromInt(s.b3t_1)) {
            tmp$ret$0 = commonToUtf8String(this.i3w(byteCount));
            break $l$block_0;
          }
          var result = commonToUtf8String(s.z3s_1, s.a3t_1, s.a3t_1 + convertToInt(byteCount) | 0);
          s.a3t_1 = s.a3t_1 + convertToInt(byteCount) | 0;
          this.k3s_1 = subtract(this.k3s_1, byteCount);
          if (s.a3t_1 === s.b3t_1) {
            this.j3s_1 = s.j3t();
            SegmentPool_instance.r3t(s);
          }
          tmp$ret$0 = result;
        }
        return tmp$ret$0;
      }
      l3w() {
        return this.m3w(9223372036854775807n);
      }
      m3w(limit) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'okio.internal.commonReadUtf8LineStrict' call
          // Inline function 'kotlin.require' call
          if (!(limit >= 0n)) {
            var message = 'limit < 0: ' + limit.toString();
            throw IllegalArgumentException().n2(toString(message));
          }
          var scanLength = limit === 9223372036854775807n ? 9223372036854775807n : add(limit, 1n);
          // Inline function 'kotlin.code' call
          var this_0 = _Char___init__impl__6a9atx(10);
          var tmp$ret$3 = Char__toInt_impl_vasixd(this_0);
          var newline = this.n3w(toByte(tmp$ret$3), 0n, scanLength);
          if (!(newline === -1n)) {
            tmp$ret$0 = readUtf8Line(this, newline);
            break $l$block_0;
          }
          var tmp;
          var tmp_0;
          if (scanLength < this.k3s_1) {
            // Inline function 'kotlin.Long.minus' call
            var tmp$ret$4 = subtract(scanLength, fromInt(1));
            var tmp_1 = this.y3t(tmp$ret$4);
            // Inline function 'kotlin.code' call
            var this_1 = _Char___init__impl__6a9atx(13);
            var tmp$ret$5 = Char__toInt_impl_vasixd(this_1);
            tmp_0 = tmp_1 === toByte(tmp$ret$5);
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            var tmp_2 = this.y3t(scanLength);
            // Inline function 'kotlin.code' call
            var this_2 = _Char___init__impl__6a9atx(10);
            var tmp$ret$6 = Char__toInt_impl_vasixd(this_2);
            tmp = tmp_2 === toByte(tmp$ret$6);
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = readUtf8Line(this, scanLength);
            break $l$block_0;
          }
          var data = new (Buffer())();
          // Inline function 'okio.minOf' call
          var b = this.k3s_1;
          // Inline function 'kotlin.comparisons.minOf' call
          var a = fromInt(32);
          var tmp$ret$7 = a <= b ? a : b;
          this.c3w(data, 0n, tmp$ret$7);
          // Inline function 'kotlin.comparisons.minOf' call
          var a_0 = this.k3s_1;
          var tmp$ret$9 = a_0 <= limit ? a_0 : limit;
          throw EOFException().a3w('\\n not found: limit=' + tmp$ret$9.toString() + ' content=' + data.g3w().f3v() + '\u2026');
        }
        return tmp$ret$0;
      }
      o3w(options) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonSelect' call
          var index = selectPrefix(this, options);
          if (index === -1) {
            tmp$ret$0 = -1;
            break $l$block;
          }
          var selectedSize = options.s3s_1[index].q2();
          this.l3s(fromInt(selectedSize));
          tmp$ret$0 = index;
        }
        return tmp$ret$0;
      }
      p3w() {
        // Inline function 'okio.internal.commonReadByteArray' call
        return this.i3w(this.k3s_1);
      }
      i3w(byteCount) {
        // Inline function 'okio.internal.commonReadByteArray' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n && byteCount <= 2147483647n)) {
          var message = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().n2(toString(message));
        }
        if (this.k3s_1 < byteCount)
          throw EOFException().f3w();
        var result = new Int8Array(convertToInt(byteCount));
        this.q3w(result);
        return result;
      }
      q3w(sink) {
        // Inline function 'okio.internal.commonReadFully' call
        var offset = 0;
        while (offset < sink.length) {
          var read = this.r3w(sink, offset, sink.length - offset | 0);
          if (read === -1)
            throw EOFException().f3w();
          offset = offset + read | 0;
        }
        return Unit_instance;
      }
      r3w(sink, offset, byteCount) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonRead' call
          checkOffsetAndCount(fromInt(sink.length), fromInt(offset), fromInt(byteCount));
          var tmp0_elvis_lhs = this.j3s_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            tmp$ret$0 = -1;
            break $l$block;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var s = tmp;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = s.b3t_1 - s.a3t_1 | 0;
          var toCopy = Math.min(byteCount, b);
          var tmp0 = s.z3s_1;
          var tmp6 = s.a3t_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = s.a3t_1 + toCopy | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp_0 = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp_0, sink, offset, tmp6, endIndex);
          s.a3t_1 = s.a3t_1 + toCopy | 0;
          this.k3s_1 = subtract(this.k3s_1, fromInt(toCopy));
          if (s.a3t_1 === s.b3t_1) {
            this.j3s_1 = s.j3t();
            SegmentPool_instance.r3t(s);
          }
          tmp$ret$0 = toCopy;
        }
        return tmp$ret$0;
      }
      a5() {
        // Inline function 'okio.internal.commonClear' call
        this.l3s(this.k3s_1);
        return Unit_instance;
      }
      l3s(byteCount) {
        // Inline function 'okio.internal.commonSkip' call
        var byteCount_0 = byteCount;
        while (byteCount_0 > 0n) {
          var tmp0_elvis_lhs = this.j3s_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw EOFException().f3w();
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var head = tmp;
          var tmp0 = byteCount_0;
          // Inline function 'okio.minOf' call
          var b = head.b3t_1 - head.a3t_1 | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b_0 = fromInt(b);
          var tmp$ret$1 = tmp0 <= b_0 ? tmp0 : b_0;
          var toSkip = convertToInt(tmp$ret$1);
          this.k3s_1 = subtract(this.k3s_1, fromInt(toSkip));
          byteCount_0 = subtract(byteCount_0, fromInt(toSkip));
          head.a3t_1 = head.a3t_1 + toSkip | 0;
          if (head.a3t_1 === head.b3t_1) {
            this.j3s_1 = head.j3t();
            SegmentPool_instance.r3t(head);
          }
        }
        return Unit_instance;
      }
      s3w(byteString) {
        // Inline function 'okio.internal.commonWrite' call
        var byteCount = byteString.q2();
        byteString.j3v(this, 0, byteCount);
        return this;
      }
      t3w(minimumCapacity) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonWritableSegment' call
          // Inline function 'kotlin.require' call
          if (!(minimumCapacity >= 1 && minimumCapacity <= 8192)) {
            var message = 'unexpected capacity';
            throw IllegalArgumentException().n2(toString(message));
          }
          if (this.j3s_1 == null) {
            var result = SegmentPool_instance.o3t();
            this.j3s_1 = result;
            result.f3t_1 = result;
            result.e3t_1 = result;
            tmp$ret$0 = result;
            break $l$block;
          }
          var tail = ensureNotNull(this.j3s_1).f3t_1;
          if ((ensureNotNull(tail).b3t_1 + minimumCapacity | 0) > 8192 || !tail.d3t_1) {
            tail = tail.k3t(SegmentPool_instance.o3t());
          }
          tmp$ret$0 = tail;
        }
        return tmp$ret$0;
      }
      u3w(string) {
        return this.v3w(string, 0, string.length);
      }
      v3w(string, beginIndex, endIndex) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.require' call
        if (!(beginIndex >= 0)) {
          var message = 'beginIndex < 0: ' + beginIndex;
          throw IllegalArgumentException().n2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(endIndex >= beginIndex)) {
          var message_0 = 'endIndex < beginIndex: ' + endIndex + ' < ' + beginIndex;
          throw IllegalArgumentException().n2(toString(message_0));
        }
        // Inline function 'kotlin.require' call
        if (!(endIndex <= string.length)) {
          var message_1 = 'endIndex > string.length: ' + endIndex + ' > ' + string.length;
          throw IllegalArgumentException().n2(toString(message_1));
        }
        var i = beginIndex;
        while (i < endIndex) {
          // Inline function 'kotlin.code' call
          var this_0 = charCodeAt(string, i);
          var c = Char__toInt_impl_vasixd(this_0);
          if (c < 128) {
            var tail = this.t3w(1);
            var data = tail.z3s_1;
            var segmentOffset = tail.b3t_1 - i | 0;
            // Inline function 'kotlin.comparisons.minOf' call
            var b = 8192 - segmentOffset | 0;
            var runLimit = Math.min(endIndex, b);
            var _unary__edvuaz = i;
            i = _unary__edvuaz + 1 | 0;
            data[segmentOffset + _unary__edvuaz | 0] = toByte(c);
            $l$loop: while (i < runLimit) {
              // Inline function 'kotlin.code' call
              var this_1 = charCodeAt(string, i);
              c = Char__toInt_impl_vasixd(this_1);
              if (c >= 128)
                break $l$loop;
              var _unary__edvuaz_0 = i;
              i = _unary__edvuaz_0 + 1 | 0;
              data[segmentOffset + _unary__edvuaz_0 | 0] = toByte(c);
            }
            var runSize = (i + segmentOffset | 0) - tail.b3t_1 | 0;
            tail.b3t_1 = tail.b3t_1 + runSize | 0;
            this.k3s_1 = add(this.k3s_1, fromInt(runSize));
          } else if (c < 2048) {
            var tail_0 = this.t3w(2);
            tail_0.z3s_1[tail_0.b3t_1] = toByte(c >> 6 | 192);
            tail_0.z3s_1[tail_0.b3t_1 + 1 | 0] = toByte(c & 63 | 128);
            tail_0.b3t_1 = tail_0.b3t_1 + 2 | 0;
            this.k3s_1 = add(this.k3s_1, 2n);
            i = i + 1 | 0;
          } else if (c < 55296 || c > 57343) {
            var tail_1 = this.t3w(3);
            tail_1.z3s_1[tail_1.b3t_1] = toByte(c >> 12 | 224);
            tail_1.z3s_1[tail_1.b3t_1 + 1 | 0] = toByte(c >> 6 & 63 | 128);
            tail_1.z3s_1[tail_1.b3t_1 + 2 | 0] = toByte(c & 63 | 128);
            tail_1.b3t_1 = tail_1.b3t_1 + 3 | 0;
            this.k3s_1 = add(this.k3s_1, 3n);
            i = i + 1 | 0;
          } else {
            var tmp;
            if ((i + 1 | 0) < endIndex) {
              // Inline function 'kotlin.code' call
              var this_2 = charCodeAt(string, i + 1 | 0);
              tmp = Char__toInt_impl_vasixd(this_2);
            } else {
              tmp = 0;
            }
            var low = tmp;
            if (c > 56319 || !(56320 <= low ? low <= 57343 : false)) {
              // Inline function 'kotlin.code' call
              var this_3 = _Char___init__impl__6a9atx(63);
              var tmp$ret$11 = Char__toInt_impl_vasixd(this_3);
              this.w3w(tmp$ret$11);
              i = i + 1 | 0;
            } else {
              var codePoint = 65536 + ((c & 1023) << 10 | low & 1023) | 0;
              var tail_2 = this.t3w(4);
              tail_2.z3s_1[tail_2.b3t_1] = toByte(codePoint >> 18 | 240);
              tail_2.z3s_1[tail_2.b3t_1 + 1 | 0] = toByte(codePoint >> 12 & 63 | 128);
              tail_2.z3s_1[tail_2.b3t_1 + 2 | 0] = toByte(codePoint >> 6 & 63 | 128);
              tail_2.z3s_1[tail_2.b3t_1 + 3 | 0] = toByte(codePoint & 63 | 128);
              tail_2.b3t_1 = tail_2.b3t_1 + 4 | 0;
              this.k3s_1 = add(this.k3s_1, 4n);
              i = i + 2 | 0;
            }
          }
        }
        return this;
      }
      x3w(source) {
        // Inline function 'okio.internal.commonWrite' call
        return this.a3u(source, 0, source.length);
      }
      a3u(source, offset, byteCount) {
        // Inline function 'okio.internal.commonWrite' call
        var offset_0 = offset;
        checkOffsetAndCount(fromInt(source.length), fromInt(offset_0), fromInt(byteCount));
        var limit = offset_0 + byteCount | 0;
        while (offset_0 < limit) {
          var tail = this.t3w(1);
          var tmp0 = limit - offset_0 | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = 8192 - tail.b3t_1 | 0;
          var toCopy = Math.min(tmp0, b);
          var tmp2 = tail.z3s_1;
          var tmp4 = tail.b3t_1;
          var tmp6 = offset_0;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = offset_0 + toCopy | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = source;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, tmp4, tmp6, endIndex);
          offset_0 = offset_0 + toCopy | 0;
          tail.b3t_1 = tail.b3t_1 + toCopy | 0;
        }
        this.k3s_1 = add(this.k3s_1, fromInt(byteCount));
        return this;
      }
      q3s(source) {
        // Inline function 'okio.internal.commonWriteAll' call
        var totalBytesRead = 0n;
        $l$loop: while (true) {
          var readCount = source.e3u(this, 8192n);
          if (readCount === -1n)
            break $l$loop;
          totalBytesRead = add(totalBytesRead, readCount);
        }
        return totalBytesRead;
      }
      w3w(b) {
        // Inline function 'okio.internal.commonWriteByte' call
        var tail = this.t3w(1);
        var _unary__edvuaz = tail.b3t_1;
        tail.b3t_1 = _unary__edvuaz + 1 | 0;
        tail.z3s_1[_unary__edvuaz] = toByte(b);
        this.k3s_1 = add(this.k3s_1, 1n);
        return this;
      }
      p3s(i) {
        // Inline function 'okio.internal.commonWriteInt' call
        var tail = this.t3w(4);
        var data = tail.z3s_1;
        var limit = tail.b3t_1;
        var _unary__edvuaz = limit;
        limit = _unary__edvuaz + 1 | 0;
        data[_unary__edvuaz] = toByte((i >>> 24 | 0) & 255);
        var _unary__edvuaz_0 = limit;
        limit = _unary__edvuaz_0 + 1 | 0;
        data[_unary__edvuaz_0] = toByte((i >>> 16 | 0) & 255);
        var _unary__edvuaz_1 = limit;
        limit = _unary__edvuaz_1 + 1 | 0;
        data[_unary__edvuaz_1] = toByte((i >>> 8 | 0) & 255);
        var _unary__edvuaz_2 = limit;
        limit = _unary__edvuaz_2 + 1 | 0;
        data[_unary__edvuaz_2] = toByte(i & 255);
        tail.b3t_1 = limit;
        this.k3s_1 = add(this.k3s_1, 4n);
        return this;
      }
      i3s(source, byteCount) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonWrite' call
          var byteCount_0 = byteCount;
          // Inline function 'kotlin.require' call
          if (!!(source === this)) {
            var message = 'source == this';
            throw IllegalArgumentException().n2(toString(message));
          }
          checkOffsetAndCount(source.k3s_1, 0n, byteCount_0);
          while (byteCount_0 > 0n) {
            if (byteCount_0 < fromInt(ensureNotNull(source.j3s_1).b3t_1 - ensureNotNull(source.j3s_1).a3t_1 | 0)) {
              var tail = !(this.j3s_1 == null) ? ensureNotNull(this.j3s_1).f3t_1 : null;
              var tmp;
              if (!(tail == null) && tail.d3t_1) {
                var tmp0 = byteCount_0;
                // Inline function 'kotlin.Long.plus' call
                var other = tail.b3t_1;
                var tmp0_0 = add(tmp0, fromInt(other));
                // Inline function 'kotlin.Long.minus' call
                var other_0 = tail.c3t_1 ? 0 : tail.a3t_1;
                tmp = subtract(tmp0_0, fromInt(other_0)) <= 8192n;
              } else {
                tmp = false;
              }
              if (tmp) {
                ensureNotNull(source.j3s_1).q3t(tail, convertToInt(byteCount_0));
                source.k3s_1 = subtract(source.k3s_1, byteCount_0);
                this.k3s_1 = add(this.k3s_1, byteCount_0);
                tmp$ret$0 = Unit_instance;
                break $l$block;
              } else {
                source.j3s_1 = ensureNotNull(source.j3s_1).l3t(convertToInt(byteCount_0));
              }
            }
            var segmentToMove = source.j3s_1;
            var movedByteCount = fromInt(ensureNotNull(segmentToMove).b3t_1 - segmentToMove.a3t_1 | 0);
            source.j3s_1 = segmentToMove.j3t();
            if (this.j3s_1 == null) {
              this.j3s_1 = segmentToMove;
              segmentToMove.f3t_1 = segmentToMove;
              segmentToMove.e3t_1 = segmentToMove.f3t_1;
            } else {
              var tail_0 = ensureNotNull(this.j3s_1).f3t_1;
              tail_0 = ensureNotNull(tail_0).k3t(segmentToMove);
              tail_0.p3t();
            }
            source.k3s_1 = subtract(source.k3s_1, movedByteCount);
            this.k3s_1 = add(this.k3s_1, movedByteCount);
            byteCount_0 = subtract(byteCount_0, movedByteCount);
          }
          tmp$ret$0 = Unit_instance;
        }
        return tmp$ret$0;
      }
      e3u(sink, byteCount) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonRead' call
          var byteCount_0 = byteCount;
          // Inline function 'kotlin.require' call
          if (!(byteCount_0 >= 0n)) {
            var message = 'byteCount < 0: ' + byteCount_0.toString();
            throw IllegalArgumentException().n2(toString(message));
          }
          if (this.k3s_1 === 0n) {
            tmp$ret$0 = -1n;
            break $l$block;
          }
          if (byteCount_0 > this.k3s_1)
            byteCount_0 = this.k3s_1;
          sink.i3s(this, byteCount_0);
          tmp$ret$0 = byteCount_0;
        }
        return tmp$ret$0;
      }
      n3w(b, fromIndex, toIndex) {
        var tmp$ret$0;
        $l$block_10: {
          // Inline function 'okio.internal.commonIndexOf' call
          var fromIndex_0 = fromIndex;
          var toIndex_0 = toIndex;
          // Inline function 'kotlin.require' call
          if (!(0n <= fromIndex_0 ? fromIndex_0 <= toIndex_0 : false)) {
            var message = 'size=' + this.k3s_1.toString() + ' fromIndex=' + fromIndex_0.toString() + ' toIndex=' + toIndex_0.toString();
            throw IllegalArgumentException().n2(toString(message));
          }
          if (toIndex_0 > this.k3s_1)
            toIndex_0 = this.k3s_1;
          if (fromIndex_0 === toIndex_0) {
            tmp$ret$0 = -1n;
            break $l$block_10;
          }
          var tmp2 = fromIndex_0;
          $l$block_11: {
            // Inline function 'okio.internal.seek' call
            var tmp0_elvis_lhs = this.j3s_1;
            var tmp;
            if (tmp0_elvis_lhs == null) {
              var tmp_0;
              if (null == null) {
                tmp$ret$0 = -1n;
                break $l$block_10;
              } else {
                tmp_0 = null;
              }
              var s = tmp_0;
              var offset = -1n;
              while (offset < toIndex_0) {
                var data = s.z3s_1;
                var tmp0 = fromInt(s.b3t_1);
                // Inline function 'kotlin.comparisons.minOf' call
                var b_0 = subtract(add(numberToLong(s.a3t_1), toIndex_0), offset);
                var tmp$ret$5 = tmp0 <= b_0 ? tmp0 : b_0;
                var limit = convertToInt(tmp$ret$5);
                var pos = convertToInt(subtract(add(numberToLong(s.a3t_1), fromIndex_0), offset));
                while (pos < limit) {
                  if (data[pos] === b) {
                    tmp$ret$0 = add(numberToLong(pos - s.a3t_1 | 0), offset);
                    break $l$block_10;
                  }
                  pos = pos + 1 | 0;
                }
                offset = add(offset, fromInt(s.b3t_1 - s.a3t_1 | 0));
                fromIndex_0 = offset;
                s = ensureNotNull(s.e3t_1);
              }
              tmp$ret$0 = -1n;
              break $l$block_10;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var s_0 = tmp;
            if (subtract(this.k3s_1, tmp2) < tmp2) {
              var offset_0 = this.k3s_1;
              while (offset_0 > tmp2) {
                s_0 = ensureNotNull(s_0.f3t_1);
                offset_0 = subtract(offset_0, fromInt(s_0.b3t_1 - s_0.a3t_1 | 0));
              }
              var tmp0_0 = s_0;
              var offset_1 = offset_0;
              var tmp_1;
              if (tmp0_0 == null) {
                tmp$ret$0 = -1n;
                break $l$block_10;
              } else {
                tmp_1 = tmp0_0;
              }
              var s_1 = tmp_1;
              var offset_2 = offset_1;
              while (offset_2 < toIndex_0) {
                var data_0 = s_1.z3s_1;
                var tmp0_1 = fromInt(s_1.b3t_1);
                // Inline function 'kotlin.comparisons.minOf' call
                var b_1 = subtract(add(numberToLong(s_1.a3t_1), toIndex_0), offset_2);
                var tmp$ret$7 = tmp0_1 <= b_1 ? tmp0_1 : b_1;
                var limit_0 = convertToInt(tmp$ret$7);
                var pos_0 = convertToInt(subtract(add(numberToLong(s_1.a3t_1), fromIndex_0), offset_2));
                while (pos_0 < limit_0) {
                  if (data_0[pos_0] === b) {
                    tmp$ret$0 = add(numberToLong(pos_0 - s_1.a3t_1 | 0), offset_2);
                    break $l$block_10;
                  }
                  pos_0 = pos_0 + 1 | 0;
                }
                offset_2 = add(offset_2, fromInt(s_1.b3t_1 - s_1.a3t_1 | 0));
                fromIndex_0 = offset_2;
                s_1 = ensureNotNull(s_1.e3t_1);
              }
              tmp$ret$0 = -1n;
              break $l$block_10;
            } else {
              var offset_3 = 0n;
              $l$loop: while (true) {
                var tmp0_2 = offset_3;
                // Inline function 'kotlin.Long.plus' call
                var other = s_0.b3t_1 - s_0.a3t_1 | 0;
                var nextOffset = add(tmp0_2, fromInt(other));
                if (nextOffset > tmp2)
                  break $l$loop;
                s_0 = ensureNotNull(s_0.e3t_1);
                offset_3 = nextOffset;
              }
              var tmp0_3 = s_0;
              var offset_4 = offset_3;
              var tmp_2;
              if (tmp0_3 == null) {
                tmp$ret$0 = -1n;
                break $l$block_10;
              } else {
                tmp_2 = tmp0_3;
              }
              var s_2 = tmp_2;
              var offset_5 = offset_4;
              while (offset_5 < toIndex_0) {
                var data_1 = s_2.z3s_1;
                var tmp0_4 = fromInt(s_2.b3t_1);
                // Inline function 'kotlin.comparisons.minOf' call
                var b_2 = subtract(add(numberToLong(s_2.a3t_1), toIndex_0), offset_5);
                var tmp$ret$10 = tmp0_4 <= b_2 ? tmp0_4 : b_2;
                var limit_1 = convertToInt(tmp$ret$10);
                var pos_1 = convertToInt(subtract(add(numberToLong(s_2.a3t_1), fromIndex_0), offset_5));
                while (pos_1 < limit_1) {
                  if (data_1[pos_1] === b) {
                    tmp$ret$0 = add(numberToLong(pos_1 - s_2.a3t_1 | 0), offset_5);
                    break $l$block_10;
                  }
                  pos_1 = pos_1 + 1 | 0;
                }
                offset_5 = add(offset_5, fromInt(s_2.b3t_1 - s_2.a3t_1 | 0));
                fromIndex_0 = offset_5;
                s_2 = ensureNotNull(s_2.e3t_1);
              }
              tmp$ret$0 = -1n;
              break $l$block_10;
            }
          }
        }
        return tmp$ret$0;
      }
      y3w(bytes) {
        return this.z3w(bytes, 0n);
      }
      z3w(bytes, fromIndex) {
        return this.a3x(bytes, fromIndex, 9223372036854775807n);
      }
      a3x(bytes, fromIndex, toIndex) {
        return commonIndexOf(this, bytes, fromIndex, toIndex);
      }
      b3x(targetBytes) {
        return this.c3x(targetBytes, 0n);
      }
      c3x(targetBytes, fromIndex) {
        var tmp$ret$0;
        $l$block_12: {
          // Inline function 'okio.internal.commonIndexOfElement' call
          var fromIndex_0 = fromIndex;
          // Inline function 'kotlin.require' call
          if (!(fromIndex_0 >= 0n)) {
            var message = 'fromIndex < 0: ' + fromIndex_0.toString();
            throw IllegalArgumentException().n2(toString(message));
          }
          var tmp2 = fromIndex_0;
          $l$block_13: {
            // Inline function 'okio.internal.seek' call
            var tmp0_elvis_lhs = this.j3s_1;
            var tmp;
            if (tmp0_elvis_lhs == null) {
              var tmp_0;
              if (null == null) {
                tmp$ret$0 = -1n;
                break $l$block_12;
              } else {
                tmp_0 = null;
              }
              var s = tmp_0;
              var offset = -1n;
              if (targetBytes.q2() === 2) {
                var b0 = targetBytes.r2(0);
                var b1 = targetBytes.r2(1);
                while (offset < this.k3s_1) {
                  var data = s.z3s_1;
                  var pos = convertToInt(subtract(add(numberToLong(s.a3t_1), fromIndex_0), offset));
                  var limit = s.b3t_1;
                  while (pos < limit) {
                    var b = data[pos];
                    if (b === b0 || b === b1) {
                      tmp$ret$0 = add(numberToLong(pos - s.a3t_1 | 0), offset);
                      break $l$block_12;
                    }
                    pos = pos + 1 | 0;
                  }
                  offset = add(offset, fromInt(s.b3t_1 - s.a3t_1 | 0));
                  fromIndex_0 = offset;
                  s = ensureNotNull(s.e3t_1);
                }
              } else {
                var targetByteArray = targetBytes.x3t();
                while (offset < this.k3s_1) {
                  var data_0 = s.z3s_1;
                  var pos_0 = convertToInt(subtract(add(numberToLong(s.a3t_1), fromIndex_0), offset));
                  var limit_0 = s.b3t_1;
                  while (pos_0 < limit_0) {
                    var b_0 = data_0[pos_0];
                    var inductionVariable = 0;
                    var last = targetByteArray.length;
                    while (inductionVariable < last) {
                      var t = targetByteArray[inductionVariable];
                      inductionVariable = inductionVariable + 1 | 0;
                      if (b_0 === t) {
                        tmp$ret$0 = add(numberToLong(pos_0 - s.a3t_1 | 0), offset);
                        break $l$block_12;
                      }
                    }
                    pos_0 = pos_0 + 1 | 0;
                  }
                  offset = add(offset, fromInt(s.b3t_1 - s.a3t_1 | 0));
                  fromIndex_0 = offset;
                  s = ensureNotNull(s.e3t_1);
                }
              }
              tmp$ret$0 = -1n;
              break $l$block_12;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var s_0 = tmp;
            if (subtract(this.k3s_1, tmp2) < tmp2) {
              var offset_0 = this.k3s_1;
              while (offset_0 > tmp2) {
                s_0 = ensureNotNull(s_0.f3t_1);
                offset_0 = subtract(offset_0, fromInt(s_0.b3t_1 - s_0.a3t_1 | 0));
              }
              var tmp0 = s_0;
              var offset_1 = offset_0;
              var tmp_1;
              if (tmp0 == null) {
                tmp$ret$0 = -1n;
                break $l$block_12;
              } else {
                tmp_1 = tmp0;
              }
              var s_1 = tmp_1;
              var offset_2 = offset_1;
              if (targetBytes.q2() === 2) {
                var b0_0 = targetBytes.r2(0);
                var b1_0 = targetBytes.r2(1);
                while (offset_2 < this.k3s_1) {
                  var data_1 = s_1.z3s_1;
                  var pos_1 = convertToInt(subtract(add(numberToLong(s_1.a3t_1), fromIndex_0), offset_2));
                  var limit_1 = s_1.b3t_1;
                  while (pos_1 < limit_1) {
                    var b_1 = data_1[pos_1];
                    if (b_1 === b0_0 || b_1 === b1_0) {
                      tmp$ret$0 = add(numberToLong(pos_1 - s_1.a3t_1 | 0), offset_2);
                      break $l$block_12;
                    }
                    pos_1 = pos_1 + 1 | 0;
                  }
                  offset_2 = add(offset_2, fromInt(s_1.b3t_1 - s_1.a3t_1 | 0));
                  fromIndex_0 = offset_2;
                  s_1 = ensureNotNull(s_1.e3t_1);
                }
              } else {
                var targetByteArray_0 = targetBytes.x3t();
                while (offset_2 < this.k3s_1) {
                  var data_2 = s_1.z3s_1;
                  var pos_2 = convertToInt(subtract(add(numberToLong(s_1.a3t_1), fromIndex_0), offset_2));
                  var limit_2 = s_1.b3t_1;
                  while (pos_2 < limit_2) {
                    var b_2 = data_2[pos_2];
                    var inductionVariable_0 = 0;
                    var last_0 = targetByteArray_0.length;
                    while (inductionVariable_0 < last_0) {
                      var t_0 = targetByteArray_0[inductionVariable_0];
                      inductionVariable_0 = inductionVariable_0 + 1 | 0;
                      if (b_2 === t_0) {
                        tmp$ret$0 = add(numberToLong(pos_2 - s_1.a3t_1 | 0), offset_2);
                        break $l$block_12;
                      }
                    }
                    pos_2 = pos_2 + 1 | 0;
                  }
                  offset_2 = add(offset_2, fromInt(s_1.b3t_1 - s_1.a3t_1 | 0));
                  fromIndex_0 = offset_2;
                  s_1 = ensureNotNull(s_1.e3t_1);
                }
              }
              tmp$ret$0 = -1n;
              break $l$block_12;
            } else {
              var offset_3 = 0n;
              $l$loop: while (true) {
                var tmp0_0 = offset_3;
                // Inline function 'kotlin.Long.plus' call
                var other = s_0.b3t_1 - s_0.a3t_1 | 0;
                var nextOffset = add(tmp0_0, fromInt(other));
                if (nextOffset > tmp2)
                  break $l$loop;
                s_0 = ensureNotNull(s_0.e3t_1);
                offset_3 = nextOffset;
              }
              var tmp0_1 = s_0;
              var offset_4 = offset_3;
              var tmp_2;
              if (tmp0_1 == null) {
                tmp$ret$0 = -1n;
                break $l$block_12;
              } else {
                tmp_2 = tmp0_1;
              }
              var s_2 = tmp_2;
              var offset_5 = offset_4;
              if (targetBytes.q2() === 2) {
                var b0_1 = targetBytes.r2(0);
                var b1_1 = targetBytes.r2(1);
                while (offset_5 < this.k3s_1) {
                  var data_3 = s_2.z3s_1;
                  var pos_3 = convertToInt(subtract(add(numberToLong(s_2.a3t_1), fromIndex_0), offset_5));
                  var limit_3 = s_2.b3t_1;
                  while (pos_3 < limit_3) {
                    var b_3 = data_3[pos_3];
                    if (b_3 === b0_1 || b_3 === b1_1) {
                      tmp$ret$0 = add(numberToLong(pos_3 - s_2.a3t_1 | 0), offset_5);
                      break $l$block_12;
                    }
                    pos_3 = pos_3 + 1 | 0;
                  }
                  offset_5 = add(offset_5, fromInt(s_2.b3t_1 - s_2.a3t_1 | 0));
                  fromIndex_0 = offset_5;
                  s_2 = ensureNotNull(s_2.e3t_1);
                }
              } else {
                var targetByteArray_1 = targetBytes.x3t();
                while (offset_5 < this.k3s_1) {
                  var data_4 = s_2.z3s_1;
                  var pos_4 = convertToInt(subtract(add(numberToLong(s_2.a3t_1), fromIndex_0), offset_5));
                  var limit_4 = s_2.b3t_1;
                  while (pos_4 < limit_4) {
                    var b_4 = data_4[pos_4];
                    var inductionVariable_1 = 0;
                    var last_1 = targetByteArray_1.length;
                    while (inductionVariable_1 < last_1) {
                      var t_1 = targetByteArray_1[inductionVariable_1];
                      inductionVariable_1 = inductionVariable_1 + 1 | 0;
                      if (b_4 === t_1) {
                        tmp$ret$0 = add(numberToLong(pos_4 - s_2.a3t_1 | 0), offset_5);
                        break $l$block_12;
                      }
                    }
                    pos_4 = pos_4 + 1 | 0;
                  }
                  offset_5 = add(offset_5, fromInt(s_2.b3t_1 - s_2.a3t_1 | 0));
                  fromIndex_0 = offset_5;
                  s_2 = ensureNotNull(s_2.e3t_1);
                }
              }
              tmp$ret$0 = -1n;
              break $l$block_12;
            }
          }
        }
        return tmp$ret$0;
      }
      d3x(offset, bytes) {
        return this.f3u(offset, bytes, 0, bytes.q2());
      }
      f3u(offset, bytes, bytesOffset, byteCount) {
        var tmp$ret$0;
        $l$block_2: {
          // Inline function 'okio.internal.commonRangeEquals' call
          if (byteCount < 0) {
            tmp$ret$0 = false;
            break $l$block_2;
          }
          var tmp;
          if (offset < 0n) {
            tmp = true;
          } else {
            // Inline function 'kotlin.Long.plus' call
            tmp = add(offset, fromInt(byteCount)) > this.k3s_1;
          }
          if (tmp) {
            tmp$ret$0 = false;
            break $l$block_2;
          }
          if (bytesOffset < 0 || (bytesOffset + byteCount | 0) > bytes.q2()) {
            tmp$ret$0 = false;
            break $l$block_2;
          }
          if (byteCount === 0) {
            tmp$ret$0 = true;
            break $l$block_2;
          }
          // Inline function 'kotlin.Long.plus' call
          var tmp0_toIndex = add(offset, fromInt(1));
          tmp$ret$0 = !(commonIndexOf(this, bytes, offset, tmp0_toIndex, bytesOffset, byteCount) === -1n);
        }
        return tmp$ret$0;
      }
      oc() {
        return Unit_instance;
      }
      l6() {
        return Unit_instance;
      }
      equals(other) {
        var tmp$ret$0;
        $l$block_3: {
          // Inline function 'okio.internal.commonEquals' call
          if (this === other) {
            tmp$ret$0 = true;
            break $l$block_3;
          }
          if (!(other instanceof Buffer())) {
            tmp$ret$0 = false;
            break $l$block_3;
          }
          if (!(this.k3s_1 === other.k3s_1)) {
            tmp$ret$0 = false;
            break $l$block_3;
          }
          if (this.k3s_1 === 0n) {
            tmp$ret$0 = true;
            break $l$block_3;
          }
          var sa = ensureNotNull(this.j3s_1);
          var sb = ensureNotNull(other.j3s_1);
          var posA = sa.a3t_1;
          var posB = sb.a3t_1;
          var pos = 0n;
          var count;
          while (pos < this.k3s_1) {
            var tmp0 = sa.b3t_1 - posA | 0;
            // Inline function 'kotlin.comparisons.minOf' call
            var b = sb.b3t_1 - posB | 0;
            var tmp$ret$1 = Math.min(tmp0, b);
            count = fromInt(tmp$ret$1);
            var inductionVariable = 0n;
            if (inductionVariable < count)
              do {
                var i = inductionVariable;
                inductionVariable = add(inductionVariable, 1n);
                var tmp = sa.z3s_1;
                var _unary__edvuaz = posA;
                posA = _unary__edvuaz + 1 | 0;
                var tmp_0 = tmp[_unary__edvuaz];
                var tmp_1 = sb.z3s_1;
                var _unary__edvuaz_0 = posB;
                posB = _unary__edvuaz_0 + 1 | 0;
                if (!(tmp_0 === tmp_1[_unary__edvuaz_0])) {
                  tmp$ret$0 = false;
                  break $l$block_3;
                }
              }
               while (inductionVariable < count);
            if (posA === sa.b3t_1) {
              sa = ensureNotNull(sa.e3t_1);
              posA = sa.a3t_1;
            }
            if (posB === sb.b3t_1) {
              sb = ensureNotNull(sb.e3t_1);
              posB = sb.a3t_1;
            }
            pos = add(pos, count);
          }
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      hashCode() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonHashCode' call
          var tmp0_elvis_lhs = this.j3s_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            tmp$ret$0 = 0;
            break $l$block;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var s = tmp;
          var result = 1;
          do {
            var pos = s.a3t_1;
            var limit = s.b3t_1;
            while (pos < limit) {
              result = imul(31, result) + s.z3s_1[pos] | 0;
              pos = pos + 1 | 0;
            }
            s = ensureNotNull(s.e3t_1);
          }
           while (!(s === this.j3s_1));
          tmp$ret$0 = result;
        }
        return tmp$ret$0;
      }
      toString() {
        return this.e3x().toString();
      }
      e3x() {
        // Inline function 'okio.internal.commonSnapshot' call
        // Inline function 'kotlin.check' call
        if (!(this.k3s_1 <= 2147483647n)) {
          var message = 'size > Int.MAX_VALUE: ' + this.k3s_1.toString();
          throw IllegalStateException().o(toString(message));
        }
        return this.j3w(convertToInt(this.k3s_1));
      }
      j3w(byteCount) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonSnapshot' call
          if (byteCount === 0) {
            tmp$ret$0 = Companion_getInstance().a3v_1;
            break $l$block;
          }
          checkOffsetAndCount(this.k3s_1, 0n, fromInt(byteCount));
          var offset = 0;
          var segmentCount = 0;
          var s = this.j3s_1;
          while (offset < byteCount) {
            if (ensureNotNull(s).b3t_1 === s.a3t_1) {
              throw AssertionError().ue('s.limit == s.pos');
            }
            offset = offset + (s.b3t_1 - s.a3t_1 | 0) | 0;
            segmentCount = segmentCount + 1 | 0;
            s = s.e3t_1;
          }
          // Inline function 'kotlin.arrayOfNulls' call
          var size = segmentCount;
          var segments = Array(size);
          var directory = new Int32Array(imul(segmentCount, 2));
          offset = 0;
          segmentCount = 0;
          s = this.j3s_1;
          while (offset < byteCount) {
            segments[segmentCount] = ensureNotNull(s).z3s_1;
            offset = offset + (s.b3t_1 - s.a3t_1 | 0) | 0;
            var tmp = segmentCount;
            // Inline function 'kotlin.comparisons.minOf' call
            var a = offset;
            directory[tmp] = Math.min(a, byteCount);
            directory[segmentCount + segments.length | 0] = s.a3t_1;
            s.c3t_1 = true;
            segmentCount = segmentCount + 1 | 0;
            s = s.e3t_1;
          }
          tmp$ret$0 = new (SegmentedByteString())(isArray(segments) ? segments : THROW_CCE(), directory);
        }
        return tmp$ret$0;
      }
    }
    initMetadataForClass($, 'Buffer', Buffer);
    BufferClass = $;
  }
  return BufferClass;
}
//region block: exports
export {
  UnsafeCursor as UnsafeCursor3vg8iqxvd6n5k,
  Buffer as Buffer3384y49aj0pxr,
};
//endregion

//# sourceMappingURL=Buffer.mjs.map
